export class MoveActionMsg {
    constructor(
        displayMoveIcon: boolean,
        message: string | null,
        doAction: boolean,
        toolTipText: string | null,
        moveToNodeText: string | null,
        id: number | null
    ) {
        this.displayMoveIcon = displayMoveIcon;
        this.message = message;
        this.doAction = doAction;
        this.toolTipText = toolTipText;
        this.moveToNodeText = moveToNodeText;
        this.id = id;
    }
    displayMoveIcon: boolean;
    message: string | null;
    doAction: boolean;
    toolTipText: string | null;
    moveToNodeText: string | null;
    id: number | null;
}
